var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timeSinceLastInvasion())?_c('span',[_vm._v("It has been "+_vm._s(_vm.timeSinceLastInvasion())+" since the last invasion.")]):_c('span',[_vm._v("One could start at any moment!")])}
var staticRenderFns = []

export { render, staticRenderFns }